import { not, equals } from 'ramda';
import { getPhoneNumber } from '../selectors/eligibility';

export const isPhoneNumberUpdated = (state, phoneNumber) => {
  const currentPhoneNumber = getPhoneNumber(state);
  return not(equals(currentPhoneNumber, phoneNumber));
};
